import { useLayout } from '@/layout/LayoutProvider';
import {
  LinearLoadingIndicator,
  LinearLoadingIndicatorProps
} from '@storeblocks/linear-loading-indicator';
import OldLoadingIndicator from '@storeblocks/loading-indicator';

const LoadingIndicator = (props: LinearLoadingIndicatorProps) => {
  const { isRebrand } = useLayout();

  return isRebrand ? (
    <LinearLoadingIndicator type="indeterminate" {...props} />
  ) : (
    <OldLoadingIndicator />
  );
};

export default LoadingIndicator;
